import { ConnectionStatusCard } from './connection-status-card.component';

import { useGetRetailerNetworkLocationPosConnectionStatusQuery } from '../../../data-access/queries';

type ConnectionStatusContainerProps = {
  retailerNetworkUuid: string;
  locationUuid: string;
};

export const ConnectionStatusContainer = ({
  retailerNetworkUuid,
  locationUuid,
}: ConnectionStatusContainerProps) => {
  const { data, loading, error } = useGetRetailerNetworkLocationPosConnectionStatusQuery({
    variables: {
      filter: {
        retailerNetworkUuidEquals: retailerNetworkUuid,
        locationUuidEquals: locationUuid,
      },
    },
  });

  return <ConnectionStatusCard terminals={data} loading={loading} error={error} />;
};
